import { AuthedPage, HeaderFooterLayout } from '../app';
import { AdminNav } from './AdminNav';

const Admin = ({ children }: { children: React.ReactNode }) => {
  return (
    <AuthedPage>
      <HeaderFooterLayout>
        <AdminNav />
        <div className='p-4'>{children}</div>
      </HeaderFooterLayout>
    </AuthedPage>
  );
};

export default Admin;
